import { env } from './shared/config/env';

const awsmobile = {
  aws_project_region: env.awsProjectRegion,
  aws_user_pools_id: env.awsUserPoolId,
  aws_user_pools_web_client_id: env.awsUserPoolClientId,
};

export default awsmobile;
